module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer__info"
  }, [_c('toggle-card', {
    attrs: {
      "heading": "Реквизиты",
      "visibility": true
    }
  }, [_c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "name": "type",
      "id": "type",
      "error": _vm.errors.first('type'),
      "data-vv-name": "type",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.localValue.type),
      callback: function($$v) {
        _vm.$set(_vm.localValue, "type", $$v)
      },
      expression: "localValue.type"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Укажите тип")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Юридическое лицо")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Физическое лицо")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("Индивидуальный предприниматель")])]), _vm._v(" "), _c('z-input-autocomplete', _vm._b({
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.localValue.type === 1 || _vm.localValue.type === 3)),
      expression: "(localValue.type === 1 || localValue.type === 3)"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: (_vm.localValue.type === 1 || _vm.localValue.type === 3),
        length: (_vm.localValue.type === 3 ? 12 : 10)
      }),
      expression: "{required: (localValue.type === 1 || localValue.type === 3), length: (localValue.type === 3 ? 12 : 10)}"
    }],
    on: {
      "select": _vm.selectCustomer,
      "clear": _vm.clearCustomer
    },
    model: {
      value: (_vm.localValue.inn),
      callback: function($$v) {
        _vm.$set(_vm.localValue, "inn", $$v)
      },
      expression: "localValue.inn"
    }
  }, 'z-input-autocomplete', {
    id: 'inn',
    name: 'inn',
    label: 'ИНН',
    required: true,
    error: _vm.errors.first('inn'),
    'data-vv-as': ' ',
    property: 'inn',
    'display-property': 'ul_inn_label',
    'data-vv-name': 'inn',
    callback: _vm.searchCustomerByInn,
    'length-on-search': 10,
    'update-on-input': true,
    default: _vm.localValue.inn
  }, false)), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (parseInt(_vm.localValue.type) === 2),
      expression: "parseInt(localValue.type) === 2"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: (parseInt(_vm.localValue.type) === 2),
        passport: true
      }),
      expression: "{required: (parseInt(localValue.type) === 2), passport: true}"
    }],
    attrs: {
      "name": "passport_number",
      "id": "passport_number",
      "label": "Номер паспорта",
      "required": "",
      "minlength": 12,
      "maxlength": 12,
      "error": _vm.errors.first('passport_number'),
      "mask": {
        regex: '[A-zА-я0-9]{2} [0-9]{2} [0-9]{6}'
      },
      "data-vv-name": "passport_number",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.localValue.passport_number),
      callback: function($$v) {
        _vm.$set(_vm.localValue, "passport_number", $$v)
      },
      expression: "localValue.passport_number"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localValue.type === 1),
      expression: "localValue.type === 1"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: (_vm.localValue.type === 1),
        length: (_vm.localValue.type === 1 ? 9 : false)
      }),
      expression: "{required: (localValue.type === 1), length: (localValue.type === 1 ? 9 : false)}"
    }],
    attrs: {
      "error": _vm.errors.first('kpp'),
      "name": "kpp",
      "id": "kpp",
      "label": "КПП",
      "required": "",
      "data-vv-name": "kpp",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.localValue.kpp),
      callback: function($$v) {
        _vm.$set(_vm.localValue, "kpp", $$v)
      },
      expression: "localValue.kpp"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:2'),
      expression: "'required|min:2'"
    }],
    attrs: {
      "name": "name",
      "id": "name",
      "required": "",
      "error": _vm.errors.first('name'),
      "label": ((_vm.localValue.type === 1 || _vm.localValue.type === 3) ? 'Название' : 'ФИО'),
      "data-vv-name": "name",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.localValue.name),
      callback: function($$v) {
        _vm.$set(_vm.localValue, "name", $$v)
      },
      expression: "localValue.name"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:1|max:1000'),
      expression: "'min:1|max:1000'"
    }],
    attrs: {
      "name": "doc_address",
      "id": "doc_address",
      "label": "Адрес для документов",
      "error": _vm.errors.first('doc_address'),
      "data-vv-name": "doc_address",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.localValue.doc_address),
      callback: function($$v) {
        _vm.$set(_vm.localValue, "doc_address", $$v)
      },
      expression: "localValue.doc_address"
    }
  })], 1), _vm._v(" "), _c('toggle-card', {
    attrs: {
      "heading": "Контактные даннные",
      "visibility": true
    }
  }, [_c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false,
        regex: _vm.phoneValidate
      }),
      expression: "{required: false, regex: phoneValidate}"
    }],
    attrs: {
      "name": "phone",
      "id": "phone",
      "label": "Номер телефона",
      "mask": "+7 (999) 999-99-99",
      "error": _vm.errors.first('phone'),
      "data-vv-name": "phone",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.localValue.phone),
      callback: function($$v) {
        _vm.$set(_vm.localValue, "phone", $$v)
      },
      expression: "localValue.phone"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false,
        email: true
      }),
      expression: "{required: false, email: true}"
    }],
    attrs: {
      "name": "email",
      "id": "email",
      "label": "Email адрес",
      "data-vv-name": "email",
      "data-vv-as": ' ',
      "error": _vm.errors.first('email')
    },
    model: {
      value: (_vm.localValue.email),
      callback: function($$v) {
        _vm.$set(_vm.localValue, "email", $$v)
      },
      expression: "localValue.email"
    }
  })], 1), _vm._v(" "), _c('toggle-card', {
    attrs: {
      "heading": "Банковские реквизиты"
    }
  }, [_c('z-select', {
    model: {
      value: (_vm.localValue.nds),
      callback: function($$v) {
        _vm.$set(_vm.localValue, "nds", $$v)
      },
      expression: "localValue.nds"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Не выбрано")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("Без НДС")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("C НДС")])]), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false,
        integer: true,
        min: 5
      }),
      expression: "{required: false, integer: true, min: 5}"
    }],
    attrs: {
      "name": "checking_account",
      "id": "checking_account",
      "label": "Р/счёт",
      "type": "number",
      "error": _vm.errors.first('checking_account'),
      "data-vv-name": "checking_account",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.localValue.checking_account),
      callback: function($$v) {
        _vm.$set(_vm.localValue, "checking_account", $$v)
      },
      expression: "localValue.checking_account"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false,
        integer: true,
        min: 3
      }),
      expression: "{required: false, integer: true, min: 3}"
    }],
    attrs: {
      "name": "correspondent_account",
      "id": "correspondent_account",
      "label": "К/счёт",
      "error": _vm.errors.first('correspondent_account'),
      "type": "number"
    },
    model: {
      value: (_vm.localValue.correspondent_account),
      callback: function($$v) {
        _vm.$set(_vm.localValue, "correspondent_account", $$v)
      },
      expression: "localValue.correspondent_account"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('z-input', {
    staticClass: "col-6",
    attrs: {
      "name": "bank",
      "id": "bank",
      "label": "Банк"
    },
    model: {
      value: (_vm.localValue.bank),
      callback: function($$v) {
        _vm.$set(_vm.localValue, "bank", $$v)
      },
      expression: "localValue.bank"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false,
        integer: true,
        min: 3
      }),
      expression: "{required: false, integer: true, min: 3}"
    }],
    staticClass: "col-6",
    attrs: {
      "name": "bic",
      "id": "bic",
      "label": "Бик",
      "type": "number",
      "error": _vm.errors.first('bic')
    },
    model: {
      value: (_vm.localValue.bic),
      callback: function($$v) {
        _vm.$set(_vm.localValue, "bic", $$v)
      },
      expression: "localValue.bic"
    }
  })], 1)], 1), _vm._v(" "), _c('toggle-card', {
    attrs: {
      "heading": "Дополнительная информация"
    }
  }, [_c('z-select', {
    model: {
      value: (_vm.localValue.is_agent),
      callback: function($$v) {
        _vm.$set(_vm.localValue, "is_agent", $$v)
      },
      expression: "localValue.is_agent"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Не выбрано")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v(" Клиент ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v(" Перевозчик ")])]), _vm._v(" "), _c('md-content', {
    class: {
      'md-invalid': _vm.errors.has('contract')
    }
  }, [_c('label', [_vm._v(" Договор ")]), _vm._v(" "), _c('z-input', {
    attrs: {
      "name": "contract"
    },
    model: {
      value: (_vm.localValue.contract),
      callback: function($$v) {
        _vm.$set(_vm.localValue, "contract", $$v)
      },
      expression: "localValue.contract"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('contract')),
      expression: "errors.has('contract')"
    }],
    staticClass: "md-error"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('contract')))])], 1), _vm._v(" "), _c('md-content', {
    class: {
      'md-invalid': _vm.errors.has('groups')
    }
  }, [_c('label', [_vm._v(" Группы ")]), _vm._v(" "), _c('z-select', {
    attrs: {
      "name": "groups",
      "multiple": "",
      "placeholder": "Не выбрано"
    },
    model: {
      value: (_vm.localValue.group_ids),
      callback: function($$v) {
        _vm.$set(_vm.localValue, "group_ids", $$v)
      },
      expression: "localValue.group_ids"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Не выбрано")]), _vm._v(" "), _vm._l((_vm.groups), function(group) {
    return _c('option', {
      key: group.id,
      domProps: {
        "value": group.id
      }
    }, [_vm._v(" " + _vm._s(group.name))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('groups')),
      expression: "errors.has('groups')"
    }],
    staticClass: "md-error"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('groups')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d32bc44","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/customers/components/CustomerInformation.vue
// module id = 1058
// module chunks = 0